<template>
  <div id="conteudo">
    <section role="modal">
      <div
        class="modal fade"
        id="problemaAcessoModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="problemaAcessoModalLabel"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title" id="problemaAcessoModalLabel">
                Problemas de Acesso
              </h4>
            </div>
            <div class="modal-body">
              <div class="row row-field" style="padding-bottom: 15px">
                <div class="col-md-12 col-sm-12">
                  <p style="text-align: justify">
                    Você digitou suas credenciais com algum erro por 3 vezes
                    seguidas.
                  </p>
                  <p style="text-align: justify">
                    Por favor,
                    <a href="https://egov.santos.sp.gov.br/sau/" target="blank">
                      abra um SAU</a
                    >
                    contando-nos que está com problema de acesso e faremos os
                    ajustes necessários.
                  </p>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <botao
                tipo="button"
                estilo="cheio-cinza"
                rotulo="Cancelar"
                icone="cancela-modal"
                dismiss="modal"
              ></botao>
              <botao
                tipo="button"
                estilo="cheio-verde"
                rotulo="Abrir SAU"
                icone="fa-external-link"
                @clicado="abreSau()"
              ></botao>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section role="banner">
      <div
        class="page-header-bg logo-login hidden-xs"
        id="header-bg-login"
      ></div>
    </section>
    <section role="login">
      <div class="main-container container">
        <div class="row">
          <div
            class="col-xs-12 col-sm-6 col-md-offset-1 col-md-5 col-lg-offset-2 col-lg-4"
            style="display: flex; justify-content: center"
          >
            <div class="card card-banner" id="login">
              <div class="container container-login">
                <div
                  class="container container-input"
                  style="font-size: 26px; font-weight: bold; padding-top: 7px"
                >
                  <img
                    src="../../assets/SshdLogo.png"
                    alt="Logotipo SSHD"
                    style="height: 58px; vertical-align: bottom"
                  />
                  SSHD
                </div>
                <div class="container container-input">
                  Entre com sua conta da prefeitura
                  <br />para acessar o sistema
                </div>
                <form @submit.prevent="valida">
                  <div class="container container-input container-input-text">
                    <div class="form-group">
                      <label for="username">SSHD</label>
                      <div class="input-group">
                        <span class="icon-addon">
                          <i class="fa fa-user fa-fw fa-lg"></i>
                        </span>
                        <input
                          type="text"
                          name="username"
                          class="form-control-credential"
                          :class="errorInputUsername"
                          v-validate="'required|min:8|max:8'"
                          data-vv-as="SSHD"
                          v-model="usuario.username"
                          value
                          id="username"
                          placeholder="sshd"
                          autofocus="autofocus"
                        />
                      </div>
                      <span v-show="errors.has('username')" class="error">{{
                        errors.first('username')
                      }}</span>
                    </div>
                  </div>
                  <div
                    class="container container-input container-input-text"
                    style="padding-top: 0px"
                  >
                    <div class="form-group">
                      <label for="password">Senha</label>
                      <div class="input-group">
                        <span class="icon-addon">
                          <i class="fa fa-lock fa-fw fa-lg"></i>
                        </span>
                        <input
                          type="password"
                          name="password"
                          id="password"
                          class="form-control-credential"
                          :class="errorInputPassword"
                          placeholder="senha"
                          data-vv-as="Senha"
                          v-validate="'required'"
                          v-model="usuario.password"
                          @keypress="checkCapsLock($event)"
                        />
                        <span class="icon-addon-right" @click="mostraSenha()">
                          <i
                            class="fa fa-eye-slash fa-lg"
                            v-if="senhaVisivel"
                          ></i>
                          <i class="fa fa-eye fa-lg" v-else></i>
                        </span>
                      </div>
                      <span v-show="errors.has('password')" class="error">{{
                        errors.first('password')
                      }}</span>
                    </div>
                  </div>
                  <div class="container container-input">
                    <button
                      type="submit"
                      class="btn btn-block btn-success btn-lg"
                    >
                      Login
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-5 col-lg-6">
            <div class="card card-default" id="login-description">
              <h3>Links Informativos</h3>
              <p></p>
              <div>
                Clique para acessar:
                <div class="contain-link">
                  
                  <div class="column">
                  <div class="links-uteis">
                    <a
                      href="https://egov.santos.sp.gov.br/contador"
                      target="_blank"
                    >
                      <i class="fa fa-usd" aria-hidden="true"></i>&nbsp;Holerite
                    </a>
                  </div>
                  <div class="links-uteis">
                    <a
                      href="https://egov.santos.sp.gov.br/legis/documents/55"
                      target="_blank"
                    >
                      <i class="fa fa-balance-scale" aria-hidden="true"></i
                      >&nbsp;Estatuto
                    </a>
                  </div>
                  <div class="links-uteis">
                    <a
                      href="https://app.pmsantos.lecom.com.br/bpm"
                      target="_blank">
                      <i class="fa fa-file-text-o" aria-hidden="true"></i>
                      Processos Digitais
                    </a>
                  </div>
                </div>
                <div class="column">
                  <div class="links-uteis">
                    <a
                      href="https://egov.santos.sp.gov.br/contador"
                      target="_blank"
                    >
                      <i class="fa fa-file-pdf-o" aria-hidden="true"></i
                      >&nbsp;Informe IR
                    </a>
                  </div>
                  <div class="links-uteis">
                    <a href="https://egov.santos.sp.gov.br/sigm_web_adm_sistema" target="_blank" rel="noopener">
                      <i class="fa fa-stethoscope" aria-hidden="true"></i>
                      &nbsp;Perícia Médica
                    </a>
                  </div>
                </div>
                </div>
              </div>
              <h3>Adição de documento</h3>
              <p></p>
              <div>
                Clique para acessar:
                <div class="contain-link">
                  <div class="links-uteis">
                    <a href="https://entrega.santos.sp.gov.br" target="_blank">
                      <i class="fa fa-cloud-upload" aria-hidden="true"></i
                      >&nbsp;Entrega
                    </a>
                  </div>
                  <div class="links-uteis">
                    <a
                      href="https://www.youtube.com/watch?v=pdymO6b7jCg&feature=youtu.be"
                      target="_blank"
                    >
                      <i class="fa fa-youtube-play" aria-hidden="true"></i
                      >&nbsp;Manual Entrega
                    </a>
                  </div>
                  <div class="links-uteis">
                    <a
                      href="https://egov.santos.sp.gov.br/websshd"
                      target="_blank"
                    >
                      <i class="fa fa-refresh" aria-hidden="true"></i
                      >&nbsp;Trocar Senha
                    </a>
                  </div>
                  <div class="links-uteis">
                    <a @click="baixaArquivo('declaracao-ausencia.doc')">
                      <i class="fa fa-file-text-o" aria-hidden="true"></i
                      >&nbsp;Declaração de Comparecimento
                    </a>
                  </div>
                  <div class="links-uteis">
                    <a @click="baixaArquivo('ANEXO I - O.S. 001-2022-GPM - VERBA TRANSPORTE - SOLICITAÇÃO.doc')">
                      <i class="fa fa-file-text-o" aria-hidden="true"></i
                      >&nbsp;Verba Transporte - Solicitação
                    </a>
                  </div>
                  <div class="links-uteis">
                    <a @click="baixaArquivo('ANEXO II - O.S. 001-2022-GPM - VERBA TRANSPORTE - DESCRIÇÃO DE CONSUMO.xls')">
                      <i class="fa fa-file-text-o" aria-hidden="true"></i
                      >&nbsp;Verba Transporte - Descrição De Consumo
                    </a>
                  </div>
                  <div class="links-uteis">
                    <a @click="baixaArquivo('manual-ferias.pdf')">
                      <i class="fa fa-file-text-o" aria-hidden="true"></i
                      >&nbsp;Manual do Agendamento de Férias
                    </a>
                  </div>
                  <div class="links-uteis">
                    <a @click="baixaArquivo('manual-de-procedimentos.pdf')">
                      <i class="fa fa-file-text-o" aria-hidden="true"></i
                      >&nbsp;Manual de Procedimentos DEGEPAT
                    </a>
                  </div>
                  <div class="links-uteis">
                    <a @click="baixaArquivo('manual-de-especificacoes-tecnicas-de-epi.pdf')">
                      <i class="fa fa-file-text-o" aria-hidden="true"></i
                      >&nbsp;Manual de Especificações Técnicas de EPI
                    </a>
                    <div class="links-uteis">
                      <a @click="baixaArquivo('cartilha_capep.pdf')">
                        <i class="fa fa-file-pdf-o" aria-hidden="true"></i>&nbsp;Cartilha de Informações da CAPEP
                      </a>
                    </div>
                    <div class="links-uteis">
                      <a @click="baixaArquivo('artemis_consignado.pdf')">
                        <i class="fa fa-file-pdf-o" aria-hidden="true"></i>&nbsp;Manual do Sistema Artemis Versão Mobile
                        (Consignado)
                      </a>
                    </div>
                    <div class="links-uteis">
                        <a @click="baixaArquivo('documento_basico_e_orientativo_sobre_pgr.pdf')">
                          <i class="fa fa-file-pdf-o" aria-hidden="true"></i>&nbsp;Documento Básico e Orientativo sobre PGR
                        </a>   
                    </div> 
                  </div>
                </div>
                </div>
              </div>
              <h3>Esqueceu sua Senha?</h3>
              <p></p>
              <div>
                <div>
                  <p>Para redefinição e geração de uma nova senha temporária, procure o <strong>Gestor de SSHD/Senhas</strong> de sua Unidade.</p>
                  <strong>Suporte técnico:</strong> (13) 3213-2755
                </div>
              </div>
              <p></p>
            </div>
          </div>
        </div>
    </section>
  </div>
</template>

<script>
import Botao from '@/components/botao';
import obtemUsuarioLogado from './obtemUsuarioLogado';
import FileHelper from '@/helpers/FileHelper';
import api from '@/services/api';

export default {
  name: 'Login',

  data() {
    return {
      usuario: {
        username: '',
        password: '',
      },
      senhaVisivel: false,
      errosDeAcesso: 0,
    };
  },
  methods: {
    getCredentials() {
      let buffer = new Buffer(
        this.usuario.username.toUpperCase() + ':' + this.usuario.password,
      );
      return buffer.toString('base64');
    },
    valida() {
      this.$validator.validateAll().then(success => {
        if (success) {
          this.acessa();
          return;
        }
        this.$root.$refs.toastr.e(
          'Favor informar os campos de usuário e senha',
          'Atenção',
        );
      });
    },
    acessa() {
      api
        .post('login', null, {
          headers: {
            Authorization: 'Basic ' + this.getCredentials(),
          },
        })
        .then(
          response => {
            // Limpa SessionStorage se for outro usuário
            this.limpaSessionStorage();
            this.$store.commit('setToken', 'Bearer ' + response.token);

            obtemUsuarioLogado(this.token);
            this.$root.$data.isAuthenticated = true;

            this.$root.$refs.toastr.s('Login efetuado', 'Sucesso');

            this.$router.push({ name: 'Home' });
            sessionStorage.removeItem('errosDeAcesso');
          },
          error => {
            this.contaErrosDeAcesso();
            if (this.errosDeAcesso >= 3) {
              jQuery('#problemaAcessoModal').modal('show');
            }
          },
        );
    },
    limpaSessionStorage() {
      const usuarioAtual = this.usuario.username.toUpperCase();
      const dadosSessionStorage = JSON.parse(sessionStorage.getItem('vuex'));
      if (dadosSessionStorage) {
        const usuarioAnterior = dadosSessionStorage.usuarioLogado.sshd;
        if (usuarioAtual !== usuarioAnterior) {
          this.$store.commit('setCadastroModelo', {});
          this.$store.commit('setFuncionarioCadastrado', {});
        }
      }
    },

    checkCapsLock(event) {
      if (event.getModifierState('CapsLock')) {
        this.$root.$refs.toastr.w('A tecla CAPS LOCK está clicada', 'Atenção');
      }
    },
    mostraSenha() {
      const campoSenha = document.querySelector('#password');
      let status = campoSenha.type;
      this.senhaVisivel = !this.senhaVisivel;
      campoSenha.type = status === 'password' ? 'text' : 'password';
    },
    contaErrosDeAcesso() {
      if (sessionStorage.errosDeAcesso) {
        this.errosDeAcesso = sessionStorage.errosDeAcesso;
      }
      this.errosDeAcesso++;
      sessionStorage.setItem('errosDeAcesso', this.errosDeAcesso);
    },
    abreSau() {
      window.open('https://egov.santos.sp.gov.br/sau/', '_blank');
      jQuery('#problemaAcessoModal').modal('hide');
    },
    baixaArquivo(arquivo) {
      FileHelper.download(arquivo, this);
    },
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    errorInputUsername() {
      if (this.errors.has('username')) return 'form-control-credential-error';
    },
    errorInputPassword() {
      if (this.errors.has('password')) return 'form-control-credential-error';
    },
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  components: {
    Botao,
  },
};
</script>

<style scoped>
h3 small {
  color: #00615c;
  font-weight: 700;
}
a {
  color: #468b35;
  transition: color 0.2s;
}

a:hover {
  color: #8db671;
}
.page-header-bg {
  overflow: hidden;
  position: relative;
  background: #00302e;
  margin-bottom: 20px;
  width: 100%;
}

.logo-login {
  background-image: url(../../assets/centralservidor-logo-texto.png);
  background-size: 450px;
  background-repeat: no-repeat;
  background-position: center center;
}

.card-banner {
  max-width: 330px;
  background: #00615c none repeat scroll 0 0;
  overflow: hidden;
}

.card-default {
  margin-bottom: 60px;
}

.card-default h3 {
  font-size: 2.4rem;
}

.container-login {
  max-width: 100%;
  padding: 30px;
  text-align: center;
  color: #d7e7d7;
}

.container-input {
  padding-top: 15px;
  max-width: 100%;
}

.container-input-text {
  text-align: left;
}

.input-group {
  display: block;
}

::placeholder {
  color: #999999;
}

.icon-addon,
.icon-addon-right {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  padding: 0 10px;
  color: #888888;
}

.icon-addon-right {
  right: 3px;
}

.form-control-credential {
  padding: 6px 40px;
  height: 40px;
  width: 100%;
  border: 1px solid #49a649;
  border-radius: 8px;
  box-shadow: none;
  color: #666666;
}

.form-control-credential:focus {
  outline: none;
  border-color: #66e9bf;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.1),
    0 0 8px rgba(255, 255, 255, 0.35);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.1),
    0 0 8px rgba(255, 255, 255, 0.35);
}

.form-control-credential-error,
.form-control-credential-error:focus {
  border: 1px solid gold;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.error {
  color: gold;
}

.btn-success {
  color: #d7e7d7;
  border-color: #3e8f3e;
  background-color: #419641;
}

.btn-success:hover {
  color: #d7e7d7;
  border-color: #358a3f;
  background-color: #3d873d;
}

.btn-lg {
  border-radius: 8px;
}

.btn-danger,
.btn-default,
.btn-info,
.btn-primary,
.btn-success,
.btn-warning {
  text-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  background-image: none;
}

.contain-link {
  display: flex;
  flex-wrap: wrap;
  max-width: 450px;
}

.links-uteis {
  cursor: pointer;
  text-align: left;
  margin: 3px 6px 3px 0;
}

.links-uteis a {
  color: #468b35;
  background-color: transparent;
  border-radius: 15px;
  padding: 3px 6px;
  transition: background-color 0.3s, color 0.3s;
}

.links-uteis a:hover {
  color: #ecfae9;
  background-color: #64b351;
}

.column {
  flex: 0 0 38%; /* Define a largura das colunas */
  max-width: 38%; 
}

#conteudo {
  margin-top: -53px;
}

#header-bg-login {
  height: 215px;
  margin-bottom: 0;
}

#login {
  margin-top: 88px;
  margin-bottom: 0;
}

#login-description {
  padding-top: 5px;
  border: none;
  box-shadow: none;
}

@media screen and (min-width: 520px) {
  .card-default {
    margin-bottom: 20px;
  }
}

@media screen and (min-width: 768px) {
  .main-container {
    margin-top: 0px;
  }
  #conteudo {
    margin-top: 0px;
  }
  #login {
    max-width: none;
    margin-top: -30px;
    margin-bottom: 30px;
  }
}

@media screen and (min-width: 992px) {
  #conteudo {
    margin-top: -53px;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?889b0bf8